import axios from 'axios'
import { config } from '../../Constants'

export const authApi = {
  authenticate,
  signup,
  updateUser,
  getMe,
  getUserById
}

function authenticate(username, password) {
  return instance.post('/auth/authenticate', { username, password }, {
    headers: { 'Content-type': 'application/json' }
  })
}

function signup(user) {
  return instance.post('/auth/signup', user, {
    headers: { 'Content-type': 'application/json' }
  })
}

function getMe(user) {
  const url = '/api/users/me';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getUserById(user, id) {
  const url = '/api/users/byid/' + id;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function updateUser(user, newUser) {
  return instance.post('/api/users/update', newUser, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': basicAuth(user)
    }
  })
}

// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL
})

function basicAuth(user) {
  return `Basic ${user.authdata}`
}
